import { render, staticRenderFns } from "./VideoGuardCall.vue?vue&type=template&id=33ef07a3&"
import script from "./VideoGuardCall.vue?vue&type=script&lang=js&"
export * from "./VideoGuardCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports